import { render, staticRenderFns } from "./SelectDocuments.vue?vue&type=template&id=65f3ebf4"
import script from "./SelectDocuments.vue?vue&type=script&lang=js"
export * from "./SelectDocuments.vue?vue&type=script&lang=js"
import style0 from "./SelectDocuments.vue?vue&type=style&index=0&id=65f3ebf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports